export const SET_USER_DATA = (state, data) => {
    state.userData = data;
}
export const SET_USER_INFO = (state, data) => {
    state.userInfo = data;
}
export const SET_JWT_TOKEN = (state, data) => {
    state.jwt = data;
}
export const SET_ENV = (state, data) => {
    state.environment = data;
}